import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";



const getVehicleInformation = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleInformation}?isAll=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getVehicleInformationById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleInformation}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertVehicleInformation = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.InsertVehicleDetails,
    input
  );
  return data;
};

const updateVehicleInformation = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateVehicleDetails,
    input
  );
  return data;
};

const deleteVehicleInformation = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.VehicleInformation}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useVehicleInformationQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleInformation],
    queryFn: () => getVehicleInformation(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetVehicleInformationByIdQuery = (input) => {
  return useQuery({
    queryKey: [`${Api_EndPoints.VehicleInformation}BYID`],
    queryFn: () => getVehicleInformationById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertVehicleInformationMutation = () => {
  return useMutation({
    mutationFn: insertVehicleInformation,
  });
};

export const useUpdateVehicleInformationMutation = () => {
  return useMutation({
    mutationFn: updateVehicleInformation,
  });
};

export const useDeleteVehicleInformationMutation = () => {
  return useMutation({
    mutationFn: deleteVehicleInformation,
  });
};

const getVehicleDetailById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllVehicleDetails}?CompanyCode=${companyCode}&VehicleNumber=${code}`
  );
  return data;
};

export const useGetVehicleInformationDetailQuery = (input) => {
  return useQuery({
    queryKey: [`${Api_EndPoints.VehicleInformation}Details`],
    queryFn: () => getVehicleDetailById(input),
    refetchOnWindowFocus: false,
  });
};
